// extracted by mini-css-extract-plugin
export default {"footer":"footer__jb+Of","contact":"contact__aDYl+"};